import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

import { FetchDeviceConfigurationArgs, fetchDeviceConfiguration } from './fetchDeviceConfiguration';

export async function fetchDms(args: FetchDeviceConfigurationArgs) {
  const { response } = await fetchDeviceConfigurationQueryInternal(args);

  return response;
}

export async function fetchDeviceConfigurationQuery(args: FetchDeviceConfigurationArgs) {
  const { configuration } = await fetchDeviceConfigurationQueryInternal(args);

  return configuration;
}

// In order to share cache we have to store raw response along with the processed configuration
// Later, fetchDeviceConfigurationQueryInternal should just become fetchDeviceConfigurationQuery
function fetchDeviceConfigurationQueryInternal({
  applicationName,
  clientTag,
  clientVersion,
  endpoint,
  platform,
  tag,
  partnerId,
  udid,
}: FetchDeviceConfigurationArgs) {
  return queryClient.fetchQuery({
    queryKey: queryKeys.configuration,
    queryFn: () =>
      fetchDeviceConfiguration({
        applicationName,
        clientTag,
        clientVersion,
        endpoint,
        platform,
        tag,
        partnerId,
        udid,
      }),
    staleTime: Infinity,
    gcTime: Infinity,
  });
}
